'use client';

import { useQuery } from '@apollo/client/react';

import { AccountBySlugDocument } from '@gql';
import { Search } from '../../../../_components/search';

import { SearchPageShell } from '../../../../_components/search-page-shell';

interface AccountSearchPageClientProps {
  accountSlug: string;
}

export function AccountSearchPageClient({
  accountSlug,
}: AccountSearchPageClientProps) {
  const { data: accountData, loading: accountLoading } = useQuery(
    AccountBySlugDocument,
    { variables: { slug: accountSlug } }
  );

  if (accountLoading) {
    return null;
  }

  const account = accountData?.accountBySlug;

  if (!account || account.__typename !== 'Account') {
    return (
      <div className="flex min-h-[50vh] items-center justify-center text-primary-main">
        Account not found.
      </div>
    );
  }

  return (
    <SearchPageShell
      accountId={account.id}
      placeName={account.companyName ?? undefined}
    >
      <Search />
    </SearchPageShell>
  );
}
